import Link from 'next/link';

import { useMutation } from 'react-query';

import { ReportFeedbackService } from 'services/core';

import LinkButton from '@core/components/linkbutton/LinkButton';

import StarRating from 'assets/icons/star-rating.svg';
import ReportIcon from '@core/assets/icons/report-icon.svg';

import classes from './ReviewCard.module.scss';


const ReviewCard = ({ review, onReport }) => {
	const { mutate: sendFeedbackReport } = useMutation(ReportFeedbackService);

	const handleReport = () => {
		if (onReport) {
			onReport(review.id);
		} else {
			sendFeedbackReport(review.id);
		}
	};

	const lectureHref = review.lecture
		? `/courses/${review.lecture.id}/${review.lecture.slug}`
		: null;

	return (
		<div className={classes['card']}>
			<div className={classes['card-header']}>
				<div className={classes['reviewer']}>
					<div className={classes['reviewer-top']}>
						<h4 className={classes['reviewer-name']}>{review.name}</h4>
						<span className={classes['rate']}>
							<StarRating />
							{review.rate}
						</span>
					</div>
					<span className={classes['date']}>Reviewed on {review.date}</span>
				</div>

				{review.lecture &&
					(lectureHref ? (
						<LinkButton kind='simple' href={lectureHref} className={classes['lecture']}>
							{review.lecture.title}
						</LinkButton>
					) : (
						<span className={classes['lecture']}>{review.lecture.title}</span>
					))}
			</div>

			<p className={classes['comment']}>{review.comment}</p>

			<button type="button" className={classes['report']} onClick={handleReport}>
				Report review
				<ReportIcon />
			</button>
		</div>
	);
};

export default ReviewCard;
